import Axios from "axios";
let API_URL = process.env.REACT_APP_BACKEND_URL;
export const LoginService = (values) => {
  return Axios.post(API_URL + `auth/adminsign_in`, values);
};
